var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c(_vm.comp,{tag:"component",attrs:{"relate-id":_vm.relateId,"raw-relate-id":_vm.rawRelateId,"form-id":_vm.relateId,"form-code":_vm.form.formCode,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }